import type { PreviewType } from '@elara/client-core/chat/tool-badges/types';
import type { ToolResultRowEnricher } from './types.js';

import { destinationRowEnricher } from './destination.js';
import { hotelRowEnricher } from './hotel.js';
import { placeRowEnricher } from './place.js';
import { roomRowEnricher } from './room.js';

export type { ToolResultRowEnricher } from './types.js';

/**
 * Registry of per-previewType row enrichers. `ToolResultRow` looks up an enricher
 * by the item's `previewType` and delegates title/subtitle/icon resolution to it.
 * Preview types without an enricher fall through to plain `item.title / subtitle / iconUrl`.
 */
export const ROW_ENRICHERS: Partial<Record<PreviewType, ToolResultRowEnricher<unknown>>> = {
  hotel: hotelRowEnricher as ToolResultRowEnricher<unknown>,
  place: placeRowEnricher as ToolResultRowEnricher<unknown>,
  destination: destinationRowEnricher as ToolResultRowEnricher<unknown>,
  room: roomRowEnricher as ToolResultRowEnricher<unknown>,
};
